module.exports = __webpack_public_path__ + "static/media/radius.64add9dc.svg";